export const designationList = [
  { name: "Chief", value: "CHIEF" },
  { name: "Dr", value: "DOCTOR" },
  { name: "Mr", value: "MR" },
  { name: "Mrs", value: "MRS" },
  { name: "Snr", value: "SENIOR" },
  { name: "Sts", value: "SAINTS" },
  { name: "Honorable", value: "HONORABLE" },
  { name: "Esq", value: "ESQUIRE" },
  { name: "Miss", value: "MISS" },
  { name: "Reverend", value: "REVEREND" },
  { name: "Prof", value: "PROFESSOR" },
  { name: "Others", value: "OTHERS" },
];

export const categories = [
  { name: "Music", value: "MUSIC" },
  { name: "Entertainment", value: "ENTERTAINMENT" },
  { name: "Technology", value: "TECHNOLOGY" },
  { name: "Religion", value: "RELIGION" },
  { name: "Sports", value: "SPORTS" },
  { name: "Career", value: "CAREER" },
  { name: "Others", value: "OTHERS" },
];

export const industries = [
  { name: "Agriculture", value: "AGRICULTURE" },
  { name: "Aviation", value: "AVIATION" },
  { name: "Art", value: "ART" },
  { name: "Media/Entertainment", value: "MEDIA" },
  { name: "Transportation/Logistics", value: "LOGISTICS" },
  { name: "Public Relations", value: "PUBLIC_RELATIONS" },
  { name: "IT Services", value: "INFORMATION_TECHNOLOGY" },
  { name: "Computer Science", value: "COMPUTER_SCIENCE" },
  { name: "Law Enforcement", value: "LAW_ENFORCEMENT" },
  { name: "Technology", value: "TECHNOLOGY" },
  { name: "Science", value: "SCIENCE" },
  { name: "Hospitality", value: "HOSPITALITY" },
  { name: "Oil and Gas", value: "OIL_AND_GAS" },
  { name: "Telecom", value: "TELECOM" },
  { name: "Finance", value: "FINANCE" },
  { name: "Trade", value: "TRADE" },
  { name: "Mining", value: "MINING" },
  { name: "Education", value: "EDUCATION" },
  { name: "Robotics", value: "ROBOTICS" },
  { name: "Automotive", value: "AUTOMOTIVE" },
  { name: "Real Estate", value: "REAL_ESTATE" },
  { name: "Marketing", value: "MARKETING" },
  { name: "Petroleum", value: "PETROLEUM" },
  { name: "E-Commerce", value: "ECOMMERCE" },
  { name: "Energy", value: "ENERGY" },
];
